import type {Item} from './model'
import {infrastructureHeld,unstickOwnerAction} from './unstickModel'
export type CommandDecision={id:string;item_id:string;job_id:string;decision_key:string;kind:string;question:string;options:{id:string;label:string}[];recommended:string;chosen:string|null;score:number;factors:{key:string;points:number;evidence:string;quote?:string}[];requires_owner:boolean;assumption:boolean;decided_by:'agent'|'nizan'|'timeout'|null;deadline_at:string|null;reversed_at:string|null;created_at:string;decided_at:string|null}
export const boardTabs=['מחכה לך','החליטו לבד','בעבודה','מוכן לשחרור','נסגר','חסמים']
export const latestDecision=(i:Item)=>i.decision_history?.[0]
export function boardTab(i:Item){
 if(['released','message_sent','no_fix'].includes(i.state))return 4
 if(infrastructureHeld(i))return unstickOwnerAction(i)?0:5
 if(i.decision_history?.some(d=>d.job_id===i.active_job&&(!d.chosen||d.reversed_at)))return 0
 if(['ready','fix_ready','releasing','confirming'].includes(i.state))return 3
 const d=latestDecision(i)
 if(d&&['agent','timeout'].includes(d.decided_by??'')&&!d.reversed_at)return 1
 return ['new','direction_ready','plan_ready','screens_ready','stuck','failed'].includes(i.state)?0:2
}
export function countdown(d:CommandDecision,now=Date.now()){
 if(!d.deadline_at||d.chosen||d.requires_owner||d.reversed_at)return ''
 const left=Date.parse(d.deadline_at)-now
 return left<=0?'זמן ההמתנה הסתיים · ממתין להמשך אוטומטי':`ימשיך לבד בעוד ${Math.ceil(left/3600000)}ש׳`
}
